import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Checkbox } from './Checkbox';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
`;

const getOptions = options =>
  options.map(option =>
    typeof option === 'string'
      ? {
          label: option,
          value: option,
        }
      : option
  );

export const Group = ({ name, value, defaultValue, onChange, disabled, options, children }) => {
  const [allValue] = useState(() =>
    options && options.length > 0
      ? getOptions(options).map(option => option.value)
      : React.Children.map(children, child => child.props.value)
  );

  const [checkedValues, setCheckedValues] = useState(value || defaultValue || []);

  const onToggleOption = useCallback(
    e => {
      const values = [...checkedValues];
      const optionIndex = values.indexOf(e.target.value);

      if (optionIndex === -1) {
        values.push(e.target.value);
      } else {
        values.splice(optionIndex, 1);
      }

      // if pass value, we do not modify checkedValue directly
      if (!value) {
        setCheckedValues(values);
      }

      if (onChange) {
        onChange(values.filter(val => allValue.includes(val)));
      }
    },
    [allValue, checkedValues, onChange, value]
  );

  useEffect(() => {
    if (value && value !== checkedValues) {
      setCheckedValues(value);
    }
  }, [checkedValues, value]);

  const childrenForRender =
    options && options.length > 0
      ? getOptions(options).map(option => (
          <Checkbox
            key={option.value}
            name={name}
            disabled={option.disabled || disabled}
            value={option.value}
            checked={checkedValues.includes(option.value)}
            onChange={onToggleOption}
          >
            {option.label}
          </Checkbox>
        ))
      : React.Children.map(children, (child, index) =>
          React.cloneElement(child, {
            key: index,
            name: name,
            checked: checkedValues.includes(child.props.value),
            onChange: onToggleOption,
          })
        );

  return <Wrapper>{childrenForRender}</Wrapper>;
};

Group.defaultProps = {
  options: [],
};
